import { wrapInput } from '@danderson00/react-forms'
import { Body, Box } from '../widgets'

export const Radio = wrapInput(
  ({ checked, name, value, label, disabled, onChange, dark }) => (
    <label style={{ display: 'flex', gap: 8, cursor: 'pointer' }}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{ appearance: 'none', width: 0, height: 0, overflow: 'hidden', position: 'absolute' }}
      />
      <Indicator checked={checked} dark={dark} />
      <Body
        alt
        color={disabled ? 'var(--grey)' : dark ? 'black' : 'white'}
        lineHeight={1.2}
      >
        {label}
      </Body>
    </label>
  ),
  { type: 'radio' }
)

const Indicator = ({ checked, dark }) => (
  <Box minWidth={19}>
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none">
      <rect x="0.859375" y="0.9375" width="17" height="17" rx="8.5" stroke={dark ? 'black' : 'white'}/>
      {checked && <circle cx="9.35938" cy="9.4375" r="5" fill="#0000FF"/>}
    </svg>
  </Box>
)